import { Role } from "@/apollo/types";

export const userRoleOptions: { value: Role; label: string }[] = [
  { value: Role.Admin, label: "Admin" },
  { value: Role.Analyst, label: "Analyst" },
];
